import script from "./HospitalPickerTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalPickerTable.vue?vue&type=script&setup=true&lang=js"

import "./HospitalPickerTable.vue?vue&type=style&index=0&id=46afa080&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46afa080"]])

export default __exports__